module.exports = __webpack_public_path__ + "static/media/prestasi.e9ec2208.jpeg";